import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function Display({ animationDuration = 600, ...props }: Props) {
  const display = React.useRef<HTMLDivElement>(null);

  function emitCloseEvent() {
    const closedClass = classNames(styles.content, styles.closedContent);

    if (display && display.current) {
      display.current.setAttribute("class", closedClass);
      setTimeout(props.closeDisplay, 600);
    }
  }

  return (
    <div className={styles.display}>
      <div className={styles.overlay} onClick={emitCloseEvent} />
      <div
        ref={display}
        className={styles.content}
        style={{ animationDuration: `${animationDuration}ms` }}
      >
        {props.children}
      </div>
    </div>
  );
}

export { Display };
